import * as React from "react";

export function Congrats() {
    return(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="158"
        height="155"
        fill="none"
        viewBox="0 0 158 155"
    >
        <path
        fill="url(#paint0_radial_2824_23611)"
        fillRule="evenodd"
        d="M78.298 14.137a.795.795 0 0 1 .784-.688c.396 0 .73.294.784.687 2.006 14.465 7.77 27.728 16.274 38.772a31.36 31.36 0 0 0-21.817 13.87 31.36 31.36 0 0 0 21.729 48.211c-8.504 11.083-14.252 24.392-16.22 38.902a.76.76 0 0 1-.75.659.76.76 0 0 1-.75-.66c-4.629-34.134-30.178-61.62-63.312-69.124a.9.9 0 0 1-.704-.875.9.9 0 0 1 .704-.875c33.054-7.485 58.561-34.859 63.278-68.88m31.997 86.38a82 82 0 0 1 32.652-15.706.946.946 0 0 0 .737-.92.946.946 0 0 0-.737-.92 82 82 0 0 1-31.867-15.09 19.21 19.21 0 1 0-.785 32.636"
        clipRule="evenodd"
        ></path>
        <path
        fill="url(#paint1_radial_2824_23611)"
        d="m151.348 132.023-.334 1.462zm-16.365 18.387 1.487.202zm-.388 0-1.487.202zm-16.412-17.922.331-1.463zm0-.454.331 1.462zm16.403-17.856 1.485.206zm.406 0-1.485.206zm-1.892-.206c-1.137 8.195-7.284 14.794-15.249 16.599l.663 2.925c9.172-2.077 16.248-9.67 17.557-19.112zm-15.249 19.979c7.985 1.809 14.143 8.437 15.257 16.661l2.973-.403c-1.284-9.475-8.372-17.101-17.567-19.184zm18.619 16.661c1.112-8.209 7.25-14.828 15.213-16.651l-.669-2.924c-9.171 2.099-16.236 9.714-17.517 19.172zm15.213-20.051c-7.943-1.819-14.07-8.409-15.205-16.589l-2.971.412c1.307 9.425 8.359 17.007 17.507 19.101zm1.356 1.7c0-.825-.574-1.521-1.356-1.7l-.669 2.924a1.255 1.255 0 0 1-.975-1.224zm-1.356 1.7a1.744 1.744 0 0 0 1.356-1.7h-3c0-.597.415-1.096.975-1.224zm-16.894 18.12c.861 0 1.568-.64 1.681-1.469l-2.973-.403a1.3 1.3 0 0 1 1.292-1.128zm-1.681-1.469c.113.829.82 1.469 1.681 1.469v-3c.664 0 1.206.493 1.292 1.128zM116.5 132.261c0 .821.572 1.514 1.351 1.69l.663-2.926c.566.128.986.633.986 1.236zm1.351-1.69a1.73 1.73 0 0 0-1.351 1.69h3c0 .603-.42 1.107-.986 1.235zm16.938-18.071c-.864 0-1.574.641-1.689 1.472l2.971.412a1.294 1.294 0 0 1-1.282 1.116zm0 3a1.294 1.294 0 0 1-1.282-1.116l2.971-.412a1.705 1.705 0 0 0-1.689-1.472z"
        ></path>
        <path
        fill="url(#paint2_radial_2824_23611)"
        fillRule="evenodd"
        d="M17.189.18a.21.21 0 0 0-.205-.18.21.21 0 0 0-.205.18C15.543 9.1 8.853 16.28.184 18.242a.236.236 0 0 0-.184.229c0 .11.077.204.184.229 8.69 1.967 15.39 9.175 16.604 18.127a.2.2 0 0 0 .196.172.2.2 0 0 0 .196-.172c1.21-8.933 7.886-16.13 16.55-18.115a.25.25 0 0 0 .193-.241.25.25 0 0 0-.193-.242C25.087 16.25 18.423 9.083 17.189.18"
        clipRule="evenodd"
        ></path>
        <path
        fill="url(#paint3_radial_2824_23611)"
        fillRule="evenodd"
        d="M152.079 107.064a.073.073 0 0 0-.145 0 7.64 7.64 0 0 1-5.868 6.389.083.083 0 0 0 0 .163 7.64 7.64 0 0 1 5.871 6.411.07.07 0 0 0 .139 0 7.64 7.64 0 0 1 5.856-6.407.09.09 0 0 0 .068-.086.09.09 0 0 0-.068-.085 7.64 7.64 0 0 1-5.853-6.385"
        clipRule="evenodd"
        ></path>
        <defs>
        <radialGradient
            id="paint0_radial_2824_23611"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(-15.5384 126.46802 -288.09764 -35.39691 127.763 26.247)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0.163" stopColor="#34CBFF"></stop>
            <stop offset="0.269" stopColor="#4DAFFC"></stop>
            <stop offset="0.401" stopColor="#B5A2E4"></stop>
            <stop offset="0.484" stopColor="#F398CA"></stop>
            <stop offset="0.618" stopColor="#F7BDC4"></stop>
            <stop offset="0.715" stopColor="#FDB697"></stop>
            <stop offset="0.834" stopColor="#FF986F"></stop>
            <stop offset="1" stopColor="#FF7FB8"></stop>
        </radialGradient>
        <radialGradient
            id="paint1_radial_2824_23611"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(-4.02842 32.78755 -74.69076 -9.17683 147.412 117.318)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0.163" stopColor="#34CBFF"></stop>
            <stop offset="0.269" stopColor="#4DAFFC"></stop>
            <stop offset="0.401" stopColor="#B5A2E4"></stop>
            <stop offset="0.484" stopColor="#F398CA"></stop>
            <stop offset="0.618" stopColor="#F7BDC4"></stop>
            <stop offset="0.715" stopColor="#FDB697"></stop>
            <stop offset="0.834" stopColor="#FF986F"></stop>
            <stop offset="1" stopColor="#FF7FB8"></stop>
        </radialGradient>
        <radialGradient
            id="paint2_radial_2824_23611"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="rotate(97.005 13.39 14.837)scale(33.4124 76.1143)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0.163" stopColor="#34CBFF"></stop>
            <stop offset="0.269" stopColor="#4DAFFC"></stop>
            <stop offset="0.401" stopColor="#B5A2E4"></stop>
            <stop offset="0.484" stopColor="#F398CA"></stop>
            <stop offset="0.618" stopColor="#F7BDC4"></stop>
            <stop offset="0.715" stopColor="#FDB697"></stop>
            <stop offset="0.834" stopColor="#FF986F"></stop>
            <stop offset="1" stopColor="#FF7FB8"></stop>
        </radialGradient>
        <radialGradient
            id="paint3_radial_2824_23611"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(-1.44133 11.73109 -26.72355 -3.28337 156.523 108.187)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0.163" stopColor="#34CBFF"></stop>
            <stop offset="0.269" stopColor="#4DAFFC"></stop>
            <stop offset="0.401" stopColor="#B5A2E4"></stop>
            <stop offset="0.484" stopColor="#F398CA"></stop>
            <stop offset="0.618" stopColor="#F7BDC4"></stop>
            <stop offset="0.715" stopColor="#FDB697"></stop>
            <stop offset="0.834" stopColor="#FF986F"></stop>
            <stop offset="1" stopColor="#FF7FB8"></stop>
        </radialGradient>
        </defs>
    </svg>
    )
};
